import { DEFAULT_VERTICAL, VERTICAL_CODES, type VerticalCode } from '@/verticals/codes'

const runtime: AureRuntimeConfig = typeof window === 'undefined' ? {} : (window.__AURE__ ?? {})
const env = import.meta.env
const apiUrl = (runtime.apiUrl || env.VITE_API_URL || '/api').replace(/\/$/, '')

const host = (value: string) => value.toLowerCase().replace(/:\d+$/, '')

const DEFAULT_DOMAINS: Record<VerticalCode, string> = {
  stays: runtime.baseDomain || env.VITE_BASE_DOMAIN || 'localhost',
  dining: env.VITE_DINING_DOMAIN || 'carta.localhost',
}

export const config = {
  domains: Object.fromEntries(
    VERTICAL_CODES.map((code) => [
      code,
      host(runtime.verticals?.[code]?.domain || DEFAULT_DOMAINS[code]),
    ]),
  ) as Record<VerticalCode, string>,
  appSubdomain: (runtime.appSubdomain || env.VITE_APP_SUBDOMAIN || 'app').toLowerCase(),
  platformHost: host(runtime.platformHost || env.VITE_PLATFORM_HOST || 'admin.localhost'),
  apiOrigin: apiUrl.replace(/\/api$/, ''),
  defaultTenant: (runtime.defaultTenant || env.VITE_DEFAULT_TENANT || '').toLowerCase(),
  mapStyleUrl:
    runtime.mapStyleUrl || env.VITE_MAP_STYLE_URL || 'https://tiles.openfreemap.org/styles/liberty',
  storeUrl: runtime.storeUrl || env.VITE_STORE_URL || 'https://aurebrisa.cl',
  salesWhatsapp: runtime.salesWhatsapp || env.VITE_SALES_WHATSAPP || '',
  demoTable: runtime.demoTable || env.VITE_DEMO_TABLE || '',
  metaPixel: runtime.metaPixel ?? {},
  clarity: runtime.clarity ?? {},
  legal: {
    company: runtime.legal?.company || env.VITE_LEGAL_COMPANY || 'Aure Brisa',
    taxId: runtime.legal?.taxId || env.VITE_LEGAL_TAX_ID || '',
    address: runtime.legal?.address || env.VITE_LEGAL_ADDRESS || '',
    email: runtime.legal?.email || env.VITE_LEGAL_EMAIL || '',
  },
}

function hostUrl(name: string, path: string) {
  const { protocol, port } = window.location
  return `${protocol}//${name}${port ? `:${port}` : ''}${path}`
}

export function appUrl(vertical: VerticalCode = DEFAULT_VERTICAL, path = '/') {
  return hostUrl(`${config.appSubdomain}.${config.domains[vertical]}`, path)
}

export function guestSiteUrl(vertical: VerticalCode, tenantSlug: string, path = '/') {
  return hostUrl(`${tenantSlug}.${config.domains[vertical]}`, path)
}

export function rootUrl(vertical: VerticalCode = DEFAULT_VERTICAL, path = '/') {
  return hostUrl(config.domains[vertical], path)
}

export function platformUrl(path = '/') {
  return hostUrl(config.platformHost, path)
}
